// Venue displays and kiosks authenticate with a read-only display token
// (docs/adr/0002), carried in the device's URL and persisted so the same
// projector doesn't need `?dt=` on every reload.
//
// Every event shares one browser origin (docs/adr/0001), so the stored
// value MUST be keyed by eventId — a projector used for event A and
// later opened at event B's display route must not silently keep
// authenticating as A. That's why `readStoredDisplayToken` takes the route's
// eventId and only ever returns a token stored under that exact key.
const storageKey = (eventId: string) => `display-token:${eventId}`

export function readStoredDisplayToken(eventId: string): string | null {
  try {
    return window.localStorage.getItem(storageKey(eventId))
  } catch {
    // Storage can throw in a locked-down webview (private browsing, an
    // embedded browser with storage disabled) — a missing token is the
    // safe fallback, not a crash.
    return null
  }
}

export function storeDisplayToken(eventId: string, token: string): void {
  try {
    window.localStorage.setItem(storageKey(eventId), token)
  } catch {
    // Best-effort: a device that can't persist just re-requires `?dt=`
    // on the next load.
  }
}
